import { type JanusCtx, type Row, requiredInt, upper } from './context.js';

export const SIZE_RANK = [
  '13456FEC-A2EE-DB46-5829-0EB2F627E1B7', 'AAC1F466-7A8B-C593-1ADC-FC402B8909D7',
  'DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC', '52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD',
  'D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C', 'CEA2946E-D395-46EA-A6E7-74D21EA2376E',
  'C94CDD74-8ACD-26B0-5C53-4CA29CF21D68', '4C33FD22-5382-15DA-1C46-F57F14378AFD',
];

/** includes/functions/janus/core/check_ability_size_compatibility.php:check_ability_size_compatibility */
export function checkAbilitySizeCompatibility(ctx: JanusCtx, ability: Row, caster: Row, target: Row): boolean {
  const above = ctx.read.value(ability, 'ability_only_works_against_size_category_number_above');
  const below = ctx.read.value(ability, 'ability_only_works_against_size_category_number_below');
  if (above == null && below == null) return true;
  const casterRank = SIZE_RANK.indexOf(upper(ctx.read.value(caster, 'size')));
  const targetRank = SIZE_RANK.indexOf(upper(ctx.read.value(target, 'size')));
  if (casterRank < 0 || targetRank < 0) return true; // PHP fails open when a size is missing.
  return above != null ? targetRank >= casterRank + requiredInt(above, 'check_ability_size_compatibility:invalid-size-delta')
    : targetRank <= casterRank + requiredInt(below, 'check_ability_size_compatibility:invalid-size-delta');
}
